import React ,{useEffect, useState} from 'react';

import './App.css';
import Schedule from './components/Schedule'
import About from './components/about'
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGa from 'react-ga'

import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';


import { Navbar,Form,FormControl,Nav,Button} from 'react-bootstrap';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    textAlign: 'right',
  },
  closeButton: {
    position: 'absolute',
    left: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const DialogContent = withStyles((theme) => ({
  root: {
    textAlign: 'right',
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);



function App() {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(()=>{
  handleClickOpen();
    ReactGa.initialize("UA-179941435-1");
    ReactGa.pageview('/');
  },[])
  return (
    <div className="App">
       <div>
     
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} >
        <DialogTitle id="customized-dialog-title" onClose={handleClose} >
        ❗שימו לב
        </DialogTitle>
        <DialogContent dividers gutterBottom >
          <Typography gutterBottom>
     ,שלום לכולם
          </Typography>
          <Typography gutterBottom style={{color:"red",backgroundColor:"yellow"}}>
          .תחנת המידע של בראודה עברה שינוי
          </Typography>
      
          <Typography gutterBottom>
          ,לצערי מבחינת זמנים אין באפשרותי להמשיך לתחזק את האתר
          </Typography>
          <Typography gutterBottom>
          .אך קיים סיכוי שלקראת הסמסטר הבא האתר יחזור לפעילות
          </Typography>
          <Typography gutterBottom>
          .תודה וסליחה
          </Typography>
   


          <Typography gutterBottom>
          
          </Typography>
         
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            המשך לאתר
          </Button>
        </DialogActions>
      </Dialog>
    </div>
       <Router>
  <Navbar bg="light" expand="lg">
  <Navbar.Brand > <Link to="/"> Braude helper</Link></Navbar.Brand>
   
    
    <Nav className="mr-auto">

    </Nav>
      
 
    <Form inline  variant="dark"  >

     
  <Link to="/about">אודות</Link>
    </Form>
  </Navbar>
  <Switch >
  <Route exact path="/">
<Schedule></Schedule>
</Route >
<Route  path="/about">
 <About/>
</Route >
</Switch>
</Router>
<a href="mailto:vladislav.bel.bel@gmail.com">יצירת קשר</a>
              
              <MDBContainer fluid>
         
                  &copy; {new Date().getFullYear()} Copyright: <a href="https://www.linkedin.com/in/vladi-belousov-8ab199193/"> Vladi Belousov software department</a>
              </MDBContainer>
    </div>
  );
}

export default App;
